import { useRegisterSW } from 'virtual:pwa-register/react';
import './UpdatePrompt.css';

function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      // Check for updates every 30 minutes
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 30 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="update-prompt">
      <span>A new version is available.</span>
      <button onClick={() => updateServiceWorker(true)}>
        Update Now
      </button>
    </div>
  );
}

export default UpdatePrompt;
